import Vue from 'vue'
import themeColorPlugin from '_lib/plugin/theme-color'
import { executeProtocol, getHeyboxEnv } from './utils'
import SentryPlugin from './plugin/sentry-runtime'
import PerformanceCollect from './plugin/performance-collect'

window.$API_HOST = /debugmode|localhost/.test(window.origin) ? 'https://heybox.debugmode.cn':  'https://api.xiaoheihe.cn'
window.$WEB_HOST = /debugmode|localhost/.test(window.origin) ? 'https://web.debugmode.cn' : 'https://web.xiaoheihe.cn'

if (IS_TEST) {
  Vue.config.productionTip = true
  Vue.config.devtools = true
  Vue.config.debug = true
} else {
  Vue.config.productionTip = false
}

if (HANDLE_ERROR && getHeyboxEnv().debug) {
  window.onerror = (msg, where) => {
    const white_list = [/pageVisible/ig, /pageHidden/ig]
    if (white_list.find(regex => regex.test(msg))) {
      return
    }
    showAlert('JS Exception', [
      msg,
      'Where: ' + where
    ].join('\n\n'))
  }
  
  Vue.config.errorHandler = (err, vm, info) => {
    console.log(err, vm, info);
    setTimeout(() => {
      try { 
        addRedModalForErrorComponent(vm.$el)
      } catch (err) {}
      showAlert('VUE Exception',[
        err,
        vm && vm.$el
          ? vm.$el.id
            ? 'ComponentID: ' + vm.$el.id
            : 'ComponentClass: ' + vm.$el.className 
          : '',
        'Info: ' + info
      ].filter(Boolean).join('\n\n'))
    })
  }
}
// 给报错的组件添加红框
function addRedModalForErrorComponent (el) {
  const modal_wrapper = document.createElement('div')
  modal_wrapper.setAttribute('style', [
    'position: relative',
    'width: 0px',
    'height: 0px'
  ].join(';'))
  
  el.insertBefore(modal_wrapper, el.firstChild)
  setTimeout(() => {
    const modal = document.createElement('div')
    if (!el.style.position) {
      el.style.position = 'relative'
    }
    modal.setAttribute('style', [
      'position: absolute',
      'top: -' + modal_wrapper.offsetTop + 'px',
      'left: -' + modal_wrapper.offsetLeft + 'px',
      'width:' + el.clientWidth + 'px',
      'height:' + el.clientHeight + 'px',
      'background: rgba(250, 60, 75, 0.2)'
    ].join(';'))
    modal_wrapper.appendChild(modal)
  })
}

function showAlert (title, msg) {
  executeProtocol({
    "protocol_type": "max_alert", 
    "title": title,
    "desc": msg,
    "confirm": "确定"
  })
}

/* 添加主题*/
if (USE_THEME) {
  Vue.use(themeColorPlugin)
}

if (IS_PRO) {
  Vue.use(SentryPlugin)
  Vue.use(PerformanceCollect)
}
export default Vue